import { platformActionApi } from '../api/PlatformActionApi'
import type { PlatformActionRequest } from '../models/platformAction.types'
import { usePlatformActionStore } from '../stores/platformActionStore'

import { DecideActionFlow } from './DecideActionFlow'
import type { FlowResult } from './platformActionFlow.types'

export function cancelPlatformActionRequest(
  workspaceId: number,
  actionId: string,
  signal?: AbortSignal,
): Promise<FlowResult<PlatformActionRequest>> {
  const flow = new DecideActionFlow({ api: platformActionApi, store: usePlatformActionStore() })
  return flow.execute(workspaceId, actionId, 'cancel', undefined, signal)
}
